import { IBooking, IBookingSearchParams } from "../types/Booking.types";
import apiFetch from './index';

export async function searchDeskBookings(searchParams: IBookingSearchParams) {
    return  await apiFetch('/api/bookings/searchDesks', {
        method: 'POST',
        body: JSON.stringify(searchParams),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include'
    });
}

export async function getMyBookings() {
    return  await apiFetch('/api/bookings/my', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function getBookingsForLayoutAndTime(floorplanId: string, startDateStr: string, endDateStr: string) {
    return  await apiFetch(`/api/bookings/for/${floorplanId}?start=${encodeURIComponent(startDateStr)}&end=${encodeURIComponent(endDateStr)}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include'
    });
}

export async function saveNewBooking(type: "room" | "desk", booking: IBooking) {
    return  await apiFetch(`/api/bookings/${type}`, {
        method: 'POST',
        body: JSON.stringify(booking),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include'
    });
}

export async function cancelBooking(booking: IBooking) {
    return  await apiFetch(`/api/bookings`, {
        method: 'DELETE',
        body: JSON.stringify(booking),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include'
    });
}

export async function getPendingBookingCount(abortController: AbortController) {
    const response =  await apiFetch(`/api/bookings/pendingApprovals/count`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController.signal
    });
    if (response.ok) {
        return await response.json() as { PendingApprovals: number };
    } else {
        return Error("Unable to get pending booking count");
    }
}

export async function getPendingBookings(abortController: AbortController) {
    const response =  await apiFetch(`/api/bookings/pendingApprovals`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        signal: abortController.signal
    });
    if (response.ok) {
        return await response.json() as IBooking[];
    } else {
        return Error("Unable to get pending bookings");
    }
}

export async function rejectBooking(bookingId: number, info: { CancellationReason?: string, CancelledByAdmin: boolean }) {
    const response =  await apiFetch(`/api/bookings/reject/${bookingId}`, {
        headers: {
            Accept: 'application/json',
            "Content-Type": "application/json"
        },
        body: JSON.stringify(info),
        credentials: 'include',
        method: "POST"
    });
    if (response.ok) {
        return true;
    } else {
        return Error("Unable to reject booking: " + response.statusText);
    }
}

export async function approveBooking(bookingId: number) {
    const response =  await apiFetch(`/api/bookings/approve/${bookingId}`, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
        method: "POST"
    });
    if (response.ok) {
        return true;
    } else {
        return Error("Unable to approve booking: " + response.statusText);
    }
}

